import { cdnImageSrcSet, cdnImageUrl } from 'lib/cdn'
import {
  productClosedSrcSet,
  productOpenSrcSet,
  productPourSrcSet,
  waterSpriteUrl,
  waterSrcSet,
} from './imageSrcSets'
import { generateManifest, journeyAssets } from './generateManifest'
import { AudioAssetItem } from 'lib/assetLoader'
import { VariantSlug } from 'data/product'

export const audioManifest: { [id in VariantSlug]: AudioAssetItem } = {
  reddRumble: {
    getUrl: (fileType) =>
      `https://assets.okapa.com/video/upload/v1664322456/audio/20_-_REDD_Rumble_Option_B_trimmed.${fileType}`,
    type: 'audio',
  },
  googieSilverline: {
    getUrl: (fileType) =>
      `https://assets.okapa.com/video/upload/v1665007047/audio/GOOGIE_SILVERLINE_GB_trimmed.${fileType}`,
    type: 'audio',
  },
  peachesCopperwire: {
    getUrl: (fileType) =>
      `https://assets.okapa.com/video/upload/v1665007045/audio/19_-_Peaches_Copperwire_Option_B_trimmed.${fileType}`,
    type: 'audio',
  },
  fetischeNoir: {
    getUrl: (fileType) =>
      `https://assets.okapa.com/video/upload/v1665007044/audio/Fetische_Noir_trimmed.${fileType}`,
    type: 'audio',
  },
  goldieSamba: {
    getUrl: (fileType) =>
      `https://assets.okapa.com/video/upload/v1665007046/audio/goldie_samba_trimmed.${fileType}`,
    type: 'audio',
  },
  mistiPinku: {
    getUrl: (fileType) =>
      `https://assets.okapa.com/video/upload/v1665007044/audio/18_-_Misti_Pinku_Option_B_trimmed.${fileType}`,
    type: 'audio',
  },
  indigoHavana: {
    getUrl: (fileType) =>
      `https://assets.okapa.com/video/upload/v1665007043/audio/16_-_Indigo_Havana_Option_B_trimmed.${fileType}`,
    type: 'audio',
  },
  bushBerryville: {
    getUrl: (fileType) =>
      `https://assets.okapa.com/video/upload/v1665007045/audio/12_-_Bush_Berryville_Option_B_trimmed.${fileType}`,
    type: 'audio',
  },
}

export const desktopManifest = generateManifest((theme) => ({
  productOpen: {
    alt: 'OKAPA water bottle with cap open',
    src: cdnImageUrl({ theme, imageName: 'Product-Open-xxl-v2' }),
    srcSet: productOpenSrcSet(theme),
    width: 441,
    height: 1667,
    type: 'image',
  },
  productPour: {
    alt: 'Water pouring from OKAPA bottle',
    src: cdnImageUrl({ theme, imageName: 'Product-Pour-v4', width: 543 }),
    srcSet: productPourSrcSet(theme),
    width: 543,
    height: 1072,
    type: 'image',
  },
  water: {
    alt: 'Flowing water',
    src: waterSpriteUrl('xl', theme),
    srcSet: waterSrcSet(theme),
    width: 500,
    height: 2000,
    type: 'image',
  },
  productAngle: {
    alt: 'OKAPA water bottle at an angle',
    src: cdnImageUrl({
      theme,
      imageName: 'Product-Angle-v4',
    }),
    width: 213,
    height: 610,
    type: 'image',
  },
  productCart: {
    alt: 'OKAPA water bottle thumbnail',
    src: cdnImageUrl({ theme, imageName: 'Product-Cart', height: 71 }),
    zoomSrcSet: cdnImageSrcSet({
      theme,
      imageName: 'Product-Cart',
      height: 71,
    }),
    width: 20,
    height: 71,
    type: 'image',
  },
  productClosed: {
    alt: 'OKAPA water bottle with cap sealed',
    src: cdnImageUrl({ theme, imageName: 'Product-Closed-v7', width: 260 }),
    zoomSrc: cdnImageUrl({ theme, imageName: 'Product-Closed-Zoom-v2' }),
    width: 260,
    height: 1003,
    type: 'image',
  },
  productSide: {
    alt: 'Side view of OKAPA water bottle',
    src: cdnImageUrl({ theme, imageName: 'Product-Side-v8', width: 775 }),
    zoomSrc: cdnImageUrl({ theme, imageName: 'Product-Side-Zoom' }),
    width: 775,
    height: 991,
    type: 'image',
  },
  productTop: {
    alt: 'Top view of OKAPA water bottle',
    src: cdnImageUrl({ theme, imageName: 'Product-Top-v2', width: 400 }),
    zoomSrc: cdnImageUrl({ theme, imageName: 'Product-Top-Zoom-v2' }),
    width: 400,
    height: 997,
    type: 'image',
  },
  productBottom: {
    alt: 'Base of OKAPA water bottle',
    src: cdnImageUrl({ theme, imageName: 'Product-Bottom-v5', width: 400 }),
    zoomSrc: cdnImageUrl({ theme, imageName: 'Product-Bottom-Zoom-v2' }),
    width: 400,
    height: 997,
    type: 'image',
  },
  ...journeyAssets(theme),
}))

export const mobileManifest = generateManifest((theme) => ({
  productOpen: {
    alt: 'OKAPA water bottle with cap open',
    src: cdnImageUrl({ theme, imageName: 'Product-Open-s-v2' }),
    srcSet: productOpenSrcSet(theme),
    width: 300,
    height: 1134,
    type: 'image',
  },
  productPour: {
    alt: 'Water pouring from OKAPA bottle',
    src: cdnImageUrl({ theme, imageName: 'Product-Pour-v4', width: 325 }),
    srcSet: productPourSrcSet(theme),
    width: 325,
    height: 642,
    type: 'image',
  },
  water: {
    alt: 'Flowing water',
    src: waterSpriteUrl('xl', theme),
    srcSet: waterSrcSet(theme),
    width: 500,
    height: 2000,
    type: 'image',
  },
  productAngle: {
    alt: 'OKAPA water bottle at an angle',
    src: cdnImageUrl({
      theme,
      imageName: 'Product-Closed-v7',
    }),
    srcSet: productClosedSrcSet(theme),
    width: 210,
    height: 800,
    type: 'image',
  },
  productCart: {
    alt: 'OKAPA water bottle thumbnail',
    src: cdnImageUrl({ theme, imageName: 'Product-Cart', height: 64 }),
    zoomSrcSet: cdnImageSrcSet({
      theme,
      imageName: 'Product-Cart',
      height: 64,
    }),
    width: 18,
    height: 64,
    type: 'image',
  },
  productClosed: {
    alt: 'OKAPA water bottle with cap sealed',
    src: cdnImageUrl({ theme, imageName: 'Product-Closed-v7', width: 200 }),
    zoomSrc: cdnImageUrl({
      theme,
      imageName: 'Product-Closed-Zoom-Mobile',
      width: 768,
    }),
    zoomSrcSet: cdnImageSrcSet({
      theme,
      imageName: 'Product-Closed-Zoom-Mobile',
      width: 768,
    }),
    width: 200,
    height: 772,
    type: 'image',
  },
  productSide: {
    alt: 'Side view of OKAPA water bottle',
    src: cdnImageUrl({ theme, imageName: 'Product-Side-v8', width: 560 }),
    zoomSrc: cdnImageUrl({
      theme,
      imageName: 'Product-Side-Zoom-Mobile',
      width: 768,
    }),
    zoomSrcSet: cdnImageSrcSet({
      theme,
      imageName: 'Product-Side-Zoom-Mobile',
      width: 768,
    }),
    width: 560,
    height: 716,
    type: 'image',
  },
  productTop: {
    alt: 'Top view of OKAPA water bottle',
    src: cdnImageUrl({ theme, imageName: 'Product-Top-v2', width: 290 }),
    zoomSrc: cdnImageUrl({
      theme,
      imageName: 'Product-Top-Zoom-Mobile-v2',
      width: 768,
    }),
    zoomSrcSet: cdnImageSrcSet({
      theme,
      imageName: 'Product-Top-Zoom-Mobile-v2',
      width: 768,
    }),
    width: 290,
    height: 723,
    type: 'image',
  },
  productBottom: {
    alt: 'Base of OKAPA water bottle',
    src: cdnImageUrl({ theme, imageName: 'Product-Bottom-v5', width: 290 }),
    zoomSrc: cdnImageUrl({
      theme,
      imageName: 'Product-Bottom-Zoom-Mobile',
      width: 768,
    }),
    zoomSrcSet: cdnImageSrcSet({
      theme,
      imageName: 'Product-Bottom-Zoom-Mobile',
      width: 768,
    }),
    width: 290,
    height: 723,
    type: 'image',
  },
  ...journeyAssets(theme),
}))
